import React from "react";
import Card from "../ui/Card";
import Switch from "../ui/Switch";
import { Eye } from "lucide-react";

import { useNavigate } from "react-router-dom";

import Button from "../ui/Button";

import PropTypes from "prop-types";

import { formatDateDDMMYYYY } from "../../hooks/commonHooks";

export default function AgentCard({ agent = {}, toggleStatus }) {
  const navigate = useNavigate();

  const handleViewDetails = () => {
    navigate(`/agents/${agent.id}`);
  };
  return (
    <Card className="p-3 m-0">
      {/* Header */}
      <div className="d-flex justify-between align-center mb-2 agent-basic-info-header">
        <h4 className="text-primary m-0">{agent.name}</h4>

        <Switch
          checked={agent.is_active}
          onChange={() => toggleStatus(agent.id)}
        />
      </div>

      {/* Agent Info */}
      <div className="text-sm mb-1">
        <strong>Email:</strong> {agent.email}
      </div>

      <div className="text-sm mb-1">
        <strong>Mobile:</strong> {agent.mobile}
      </div>

      <div className="text-sm mb-1">
        <strong>Industry:</strong> {agent.industry}
      </div>

      <div className="d-flex justify-between text-sm mt-2">
        <span>
          <strong>Leads:</strong> {agent.leads_count}
        </span>

        <span>
          <strong>Properties:</strong> {agent.properties_count}
        </span>
      </div>

      <div className="text-xs text-muted mt-1">
        Created: {formatDateDDMMYYYY(agent.created_at)}
      </div>

      {/* Actions */}
      <div className="d-flex gap-2 mt-2 justify-content-end align-items-center">
          <Button
          variant="outline"
          onClick={handleViewDetails}
          className="d-flex align-center gap-1"
        >
          <Eye size={18} /> View Details
        </Button>
      </div>
    </Card>
  );
}


/* ✅ Prop Validation */
AgentCard.propTypes = {
  agent: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string,
    email: PropTypes.string,
    mobile: PropTypes.string,
    industry: PropTypes.string,
    crm_webhook_url: PropTypes.string,
    is_active: PropTypes.bool,
    leads_count: PropTypes.number,
    properties_count: PropTypes.number,
    primary_budget_buffer_percent: PropTypes.number,
    secondary_budget_buffer_percent: PropTypes.number,
    created_at: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date),
    ]),
  }).isRequired,

  toggleStatus: PropTypes.func.isRequired,
};